export default __webpack_public_path__ + "static/media/caret.59a32e5d.svg";